import PageTitle from "components/PageTitle";
import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Form, FormControl, Modal, Toast } from "react-bootstrap";
import Table from "components/TableComp";

import { ConfirmAlert } from "components";
import {
  createCategoria,
  deleteCategoria,
  getCategorias,
  ICategoria,
  updateCategoria,
} from "helpers/api/categoria";

interface IColunaTabela {
  row: any;
  deleteFn?: (rowId: number | string) => Promise<void>;
  toggleOpcao?: (id: string) => void;
  editFn?: (id: number, nome: string) => void;
}

export function ColunaAction({
  row,
  deleteFn,
  toggleOpcao,
  editFn,
}: IColunaTabela) {
  const handleEdit = () => {
    editFn?.(row.original.id, row.original.nome);
  };

  return (
    <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
      <span
        className="action-icon"
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          handleEdit();
        }}
        title="Editar"
      >
        <i className="mdi mdi-square-edit-outline" />
      </span>

      {toggleOpcao && (
        <span
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            toggleOpcao(String(row.original.id));
          }}
          title="Gerenciar opções"
        >
          <i className="mdi mdi-format-list-checks" />
        </span>
      )}

      <ConfirmAlert
        text={`Excluir o item "${row.original.nome}"?`}
        cb={async () => await deleteFn!(row.original.id)}
      >
        <span style={{ cursor: "pointer", margin: "2px" }} title="Excluir">
          <i className="mdi mdi-delete" />
        </span>
      </ConfirmAlert>
    </div>
  );
}

export default function Categoria() {
  const [loading, setLoading] = useState(false);
  const [categorias, setCategorias] = useState<ICategoria[]>([]);
  const [createModal, setCreateModal] = useState(false);
  const [categoria, setCategoria] = useState<ICategoria>({ nome: "" });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        setLoading(true);
        const { data } = await getCategorias();
        console.log(data)
        setCategorias(data);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };
    fetchCategorias();
  }, []);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Currículo", path: "#" },
          {
            label: "Categoria",
            path: "/curriculo/categoria",
            active: true,
          },
        ]}
        title="Gerenciamento de Categorias"
      />
      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 1050,
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={2000}
          autohide
          bg={toastType === "success" ? "success" : "danger"}
        >
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </div>

      <Card>
        <Card.Body
          style={{
            maxHeight: "1000000px",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="header-title mb-0">Categorias</h4>
            <Button
              variant="primary"
              onClick={() => {
                setCreateModal(true);
              }}
            >
              <i className="mdi mdi-plus-circle me-1" />
              Criar categoria
            </Button>
          </div>
          <p className="text-muted small">
            Gerencie as categorias de programa.
          </p>
          <Table
            columns={[
              {
                Header: "Categoria",
                accessor: "id",
                Cell: ({ row }: any) => {
                  const id = row.original.id;
                  const nome = row.original.nome;
                  return (
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                        {nome}
                        <div style={{
                            minWidth: "4%",
                            borderRadius: '15%',
                            backgroundColor: `${row.original.cor ? row.original.cor : ''}`
                        }}/>
                    </div>
                  );
                },
                sort: false,
              },
              {
                Header: "",
                accessor: "nome",
                Cell: ({ row }: any) => {
                  return (
                    <ColunaAction
                      row={row}
                      deleteFn={async (id: string | number) => {
                        await deleteCategoria(id);
                        setCategorias(
                          categorias.filter((c) => {
                            return c.id != id;
                          }),
                        );
                      }}
                      editFn={async (id: number, nome: string) => {
                        setCategoria({ id: row.original.id, nome: nome, cor: row.original.cor });
                        console.log(row.original.id);
                        setEditModal(true);
                      }}
                    />
                  );
                },
              },
            ]}
            data={categorias}
          />
        </Card.Body>
      </Card>
      <Modal
        show={createModal}
        onHide={() => {
          setCreateModal(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>Criar Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>Categoria</Form.Label>
            <FormControl
              type="text"
              value={categoria.nome}
              placeholder="Digite o nome da Categoria"
              onChange={(e) => {
                setCategoria({ nome: e.target.value });
              }}
            ></FormControl>
                      <div style={{
            marginTop: "10px"
          }}>
             <Form.Label>Cor de categoria</Form.Label>
            <FormControl
                type="color"
                value={categoria.cor ? categoria.cor : '#0d6efd'}
                onChange={(e) => {
                  setCategoria((prev) => ({
                    ...prev,
                    cor: e.target.value,
                  }));
                  console.log(categoria)
                }}
              />            
          </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setCreateModal(false)}>
            Cancelar
          </Button>
          <Button
            onClick={async () => {
              try {
                const cat = await createCategoria(categoria);
                setCategorias((prev) => prev.concat(cat.data));
                setCreateModal(false);
                setShowToast(true);
                setCategoria({ nome: "" });
                setToastMessage("Categoria criada com sucesso");
                setToastType("success");
              } catch {
                setShowToast(true);
                setToastMessage("Não foi possível criar categoria");
                setToastType("error");
              }
            }}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={editModal}
        onHide={() => {
          setEditModal(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>Editar Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>Categoria</Form.Label>
            <FormControl
              type="text"
              value={categoria.nome}
              placeholder="Digite o nome da Categoria"
              onChange={(e) => {
                setCategoria((prev) => {
                  return { id: prev.id!, nome: e.target.value };
                });
              }}
            ></FormControl>
          </Form>
          <div style={{
            marginTop: "10px"
          }}>
             <Form.Label>Cor de categoria</Form.Label>
            <FormControl
                type="color"
                value={categoria.cor ? categoria.cor : '#0d6efd'}
                onChange={(e) => {
                  setCategoria((prev) => ({
                    ...prev,
                    cor: e.target.value,
                  }));
                }}
              />            
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setEditModal(false)}>
            Cancelar
          </Button>
          <Button
            onClick={async () => {
              try {
                await updateCategoria(categoria.id!, categoria.nome, categoria.cor ? categoria.cor : '#898989');
                setCategorias((prev) =>
                  prev
                    .filter((p) => {
                      return p.id != categoria.id!;
                    })
                    .concat({ nome: categoria.nome, id: categoria.id!, cor: categoria.cor }),
                );
                setCategoria({ nome: "" });
                setEditModal(false);
                setShowToast(true);
                setToastMessage("Categoria editada com sucesso");
                setToastType("success");
              } catch {
                setShowToast(true);
                setToastMessage("Não foi possível editar categoria");
                setToastType("error");
              }
            }}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
